AppTabs.createTab( {
	name: 'overdue-jobs',
	icon: 'tachometer-alt',
	text: 'Overdue Jobs',
	create: function(init) {
		'use strict'

		init.setDataTableArgs( {

			tableId: 		'#data-table-overdue-jobs',

			readTableName: 	'viewOverdueJobs',
			primaryKey: 	'JobID',

			canSort:			true,
			paging:				false,

			actionData:			'datatable',

			fields: [
				{
					label: 		'Project',
					columnName: 'JobNumber',
					type:       'view-project-data-link',
				},
				{
					label: 		'Client',
					columnName: 'ClientName',
					type:       'client-link',
				},
				{
					label: 		'Project Name',
					columnName: 'JobDescription',
					type:       'project-name-link',
				},
				{
					label: 		'Due Date',
					columnName: 'DueDate',
					type:       'date',
				},
				{
					label: 		'Job Status',
					columnName: 'JobStatus',
				},
			],

		} );
	},
} );
